export default __webpack_public_path__ + "static/media/title-category.f1f0a741.png";